import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import Modal from '../Modal';
import YetToBeImplemented from '../YetToBeImplemented/YetToBeImplemented';
import './CDeleteLesson.css';
import './CEdit.css';

function CDeleteLesson() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div className="CDLES" onClick={() => setIsOpen(true)}>
        <div className="CDLES_A3">
          <FontAwesomeIcon icon={faTrash} />
        </div>
        <div className="CDLES_A2">
          Delete Lesson
        </div>
      </div>
      <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
        <div> <YetToBeImplemented /> </div>
      </Modal>
    </div>
  );
}

export default CDeleteLesson;
